export default __webpack_public_path__ + "static/media/login-bg.14b6fb88.png";